import {Graphics, Text} from "pixi.js";
import {Container} from "./Container";
import {GameDispatcher} from "../../base/GameDispatcher";
import {Input} from "@pixi/ui";
import {MovieMold} from "../library/MovieMold";
import {LibraryFlump} from "../library/LibraryFlump";
import {GameObject} from "../../base/GameObject";


export class TextInput extends Container {

  public static hack_currentInputPlaceholder = '';

  public onChange = new GameDispatcher(this);
  public onEnter = new GameDispatcher(this);

  protected _input?: Input | null;
  protected _inputText = '';
  protected _inputPlaceholderText = '';

  constructor(mold: MovieMold, library: LibraryFlump) {
    super(mold, library);
  }

  get input() {
    return this._input;
  }

  get text() {
    return this._input!.value;
  }

  set text(value: string) {
    this._input!.value = value;
  }

  extractText() {
    for (let i = 0; i < this._mold.layers.length; i++) {
      const moldLayer = this._mold.layers[i];
      let layerName: string = moldLayer.name;
      if (layerName.indexOf(LibraryFlump.FLUMP_TEXT) > -1) {
        return layerName.replace(LibraryFlump.FLUMP_TEXT, '');
      }
    }
    return '';
  }

  override build() {
    super.build();

    const place = this.getPlacerByLabel('text');

    const border = this.root.adapt(15);
    const radius = this.root.adapt(20);
    const width = place.width;
    const height = place.height;
    const paddingLeft = this.root.adapt(120); // to give room for icon
    const paddingRight = this.root.adapt(30);
    const paddingTop = this.root.adapt(10);

    this._input = new Input({
      TextClass: Text,
      nineSliceSprite: [0,0,0,0],
      bg: new Graphics()
        .roundRect(0, 0, width, height, radius + border)
        .fill('#9C6F06')
        .roundRect(border, border, width - (border * 2), height - (border * 2), radius)
        .fill('#F5EADA'),
      textStyle: {
        fill: '#9C6F06',
        fontSize: 75,
        fontWeight: 'bold',
      },
      maxLength: 30,
      align: 'left',
      placeholder: TextInput.hack_currentInputPlaceholder,
      secure: false,
      value: this._inputText,
      padding: {
        left: paddingLeft,
        right: paddingRight,
        top: 0,
        bottom: 0,
      },
      cleanOnFocus: false,
      addMask: true,
    });

    this._input.onEnter.connect(this.onInputEnter.bind(this));
    this._input.onChange.connect(this.onInputChange.bind(this));

    this._input.x = place.x;
    this._input.y = place.y;
    this.addChild(this._input);

    this.setChildIndex(this.getChildByLabel('btn_edit')!, this.children!.length - 1);
  }

  override destroy() {
    super.destroy();
    this._input = GameObject.destroy(this._input);
    GameObject.destroy(this.onChange);
    GameObject.destroy(this.onEnter);
  }

  protected onInputChange(val: string) {
    this.onChange.dispatch(this._input!.value);
    // Main.log(this._input!.value);
  }

  protected onInputEnter(val: string) {
    this.onEnter.dispatch(this._input!.value);
    // Main.log(this._input!.value);
  }
}
